export interface AccessibilityPrefs {
  nightMode: boolean;
  colorblindMode: boolean;
}

export const DEFAULT_ACCESSIBILITY_PREFS: AccessibilityPrefs = {
  nightMode: false,
  colorblindMode: false,
};

function defaultPrefs(): AccessibilityPrefs {
  return { ...DEFAULT_ACCESSIBILITY_PREFS };
}

export function mergeAccessibility(raw: unknown): AccessibilityPrefs {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) {
    return defaultPrefs();
  }
  const r = raw as Record<string, unknown>;
  return {
    nightMode: !!r['nightMode'],
    colorblindMode: !!r['colorblindMode'],
  };
}
